export default "__VITE_ASSET__CLIAwjJv__"